import React from "react";

const NavbarMargin = () => {
  return (
    <>
      <div class="mt-16"></div>
    </>
  );
};
export default NavbarMargin;
